import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  switchLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  },
  searchIcon: {
    '& svg': {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  stepperContainer: {
    margin: '0 auto',
    maxWidth: '400px',
  },
}));

export { useStyles };
